import { useContext } from "react";

import { PageContext } from "@/components/ui/page";

export function usePage() {
  return useContext(PageContext);
}
